import { FunctionalComponent, h } from 'preact';

import { galleryScrollIndicatorGetTransform } from 'common/module/gallery-scroll-indicator/get-transform';
import { GalleryScrollIndicatorTemplatePropsInterface } from 'common/module/gallery-scroll-indicator/template-props.interface';

export const GalleryScrollIndicatorTemplate: FunctionalComponent<GalleryScrollIndicatorTemplatePropsInterface> = (
  props
) => (
  <div
    className={`
          gallery-scroll-indicator
          ${props.isStatic ? 'gallery-scroll-indicator--static' : ''}
          ${props.mainClass ? props.mainClass : ''}
        `}
  >
    <div
      className='gallery-scroll-indicator__items'
      style={
        !props.isStatic && {
          transform: `translateX(${galleryScrollIndicatorGetTransform({
            items: props.items,
            itemWidth: props.itemWidth,
          })}px)`,
        }
      }
    >
      {props.items.map((item) => (
        <div
          className={`
            gallery-scroll-indicator__item
            ${item.isActive ? 'gallery-scroll-indicator__item--active' : ''}
            ${item.isSmall ? 'gallery-scroll-indicator__item--small' : ''}
            ${item.isHidden ? 'gallery-scroll-indicator__item--hidden' : ''}
          `}
        />
      ))}
    </div>
  </div>
);
